<template>
  <div v-if="!readOnly" class="d-flex">
    <span class="p-float-label inline flex-grow-1">
      <AnimatedInput v-model="name.given" type="text" :label="i18n.$gettext('Firstname')" @blur="$emit('blur')" />
    </span>
    <span v-if="additional && name.additional" class="p-float-label inline flex-grow-1" :class="{ 'mx-2': !isOnMobile, 'my-2': isOnMobile }">
      <Tags
          v-model="name.additional"
          multiple
          :get-autocomplete-items="() => []"
      />
      <label><translate>Middlenames</translate></label>
    </span>
    <span class="p-float-label inline flex-grow-1" :class="{ 'ml-2': !additional }">
      <AnimatedInput v-model="name.family" type="text" :label="i18n.$gettext('Lastname')" @blur="$emit('blur')" />
    </span>
  </div>
  <div v-else class="d-flex align-items-center">
    <i class="cil-contact" />&nbsp;&nbsp;<strong><translate>Name</translate>:</strong>&emsp; <p class="m-0">{{ formattedName }}</p>
  </div>
</template>

<script lang="ts">

import {Options, Vue} from "vue-class-component"
import StructuredName from "@/model/common/carddav/StructuredName"
import breakpointUtil from "@/util/BreakpointUtil"
import AnimatedInput from "@/components/common/AnimatedInput.vue"
import {useGettext} from "@jshmrtn/vue3-gettext"
import Tags from "@/components/common/Tags.vue"

@Options({
  components: {AnimatedInput, Tags},
  //@ts-ignore
  props: {
    name: [StructuredName, Object],
    readOnly: {
      type: Boolean,
      default: false
    },
    additional: {
      type: Boolean,
      default: true
    }
  },
  emits: [ 'blur' ]
})
export default class StructuredNameField extends Vue {

  i18n = useGettext()

  name!: StructuredName

  get isOnMobile(){
    return breakpointUtil.isOnMobile()
  }

  get formattedName(): string {
    return (((this.name.given || '') + ' ' + this.joinAdditional).trim() + ' ' + (this.name.family || '')).trim()
  }

  get joinAdditional(): string {
    return (this.name?.additional || []).join(' ')
  }
}
</script>

<style scoped lang="scss">

</style>
